DealLazyLoader = window.DealLazyLoader =
  sleepyLoadImages: () ->
    $('.sleepy-load:not(.lazy-loaded)').lazyload({skip_invisible: false})

  init: (payload, done) ->
    $(document.body).on 'modal-open', (e, data) ->
      $('#' + data.id).find('.lazy-load').lazyload()

    Groupon.Utils.lazyLoadImages({skip_invisible: false})
    DealLazyLoader.sleepyLoadImages()

    done()

module.exports = DealLazyLoader
